<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Crie sua conta</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas apenas para analisarmos o seu perfil.
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
            <p>
              O empréstimo só acontece se você solicitar uma proposta, aprová-la e fizer o upload da documentação pedida no site.
            </p>              
          </div>        
        </div>
        <social-network/>
      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form">
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Seja bem-vindo(a)</h2>

            <span class="other">Crie uma senha para começar a usar a plataforma.</span>
            <form  @submit.prevent="login">
              <div class="form-group text-left">
                <label for="password">Senha</label> 
                <input type="password" class="form-control form-control-lg" v-model="password">
              </div>
              <div class="form-group text-left">
                <label for="confirmarpassword">Confirmar senha</label> 
                <input type="password" class="form-control form-control-lg" v-model="confirmarpassword">
              </div>
              <div class="form-check text-left d-flex justify-content-center">
                <div class="checkboxContainer">
                  <input class="form-check-input" type="checkbox" v-model="enabled">
                  <span class="checkmark"></span>
                </div>
                <div>
                  <label class="form-check-label">
      				      Eu "CONCORDO" com os <a :href="lpUrl+'/termos-e-condicoes'" target="_blank">Termos e condições</a> e <a :href="lpUrl+'/politica-de-privacidade'" target="_blank">Política de privacidade</a> da IOUU.
      				    </label>
                </div>
      				</div>
              	<button class="btn btn-lg btn-primary" :disabled="!enabled">Cadastrar</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/_variables";
  @import '../assets/styles/iouu/_mixins.scss';

  .form-check-label {
    &{
      padding-left: 0;
    }

    @include xs {
      padding-left: 10px;
    }
  }

  // CHECKBOX - CUSTOM 
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 25px;
			height: 25px;
			margin-right: 10px;
    }
    
		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}
	
		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 25px;
		  height: 25px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;
	
		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}
	
		.checkmark {
		  position: absolute;
		  top: -4px;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;
	
		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 9px;
			top: 5px;
			width: 8px;
			height: 13px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }
	
		}
	
		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM

  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }

    .form {
      h2 {
        padding-bottom: 40px;
      }
    }
  }
</style>

<script>
import ApiClient from '../utils/api-client'
import SocialNetwork from '../components/SocialNetwork'

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      password: '',
      confirmarpassword: '',
      id: '',
      token: '',
      enabled: false
    }
  },
  components: {
    SocialNetwork
  },
  methods: {
    login: function(e) {
      e.preventDefault()
      const query = this.$route.query

      if(this.password == '' || this.confirmarpassword == '') {
        this.$Notify.error("Erro: Ambos os campos devem ser preenchidos com valores!")
      } else if (this.password.length < 6) {
        this.$Notify.error("Erro: A senha deve conter no mínimo 6 caracteres!")
      } else if (this.password != this.confirmarpassword) {
        this.$Notify.error("Erro: As senhas devem ser iguais!")
      } else {
        //alterar senha do usuário por ID.
        this.id = query.token;
        this.token = query.tk;

        var dados = this;

        ApiClient.criarnovasenha(dados)
        .then(() => {
          this.$router.push("/login")
          this.$Notify.info('Sua senha foi atualizada com sucesso.')
        })
        .catch(error => {
          if (error != "") {
            this.$router.push("/recuperar-senha")
            this.$Notify.error("Erro: Este link expirou! Solicite outro! ")
          }
        })
      }
      
    },
    facebookLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/facebook/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },
    googleLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/google/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },
    linkedinLogin(e) {
      e.preventDefault()
      ApiClient.get('oauth/linkedin/url')
        .then(response => {
          window.location.href = response.data.loginUrl
        })
    },

    taggingGA() {
      this.$ga.page({
          page: '/cadastrar-senha',
          title: 'CadastrarSenha',
      })
    },
  },

  async created() {
    await this.taggingGA()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/CadastrarSenha.vue